import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function countryRegionsListRequest(urlParams = {}) {
  let url = urls.countryRegionsList;

  if (urlParams.page) {
    url = urls.countryRegionsListPsf;
  }

  return request({
    method: 'get',
    url,
    urlParams,
    headers: getHeaders(),
  });
}

export async function countryRegionsItemRequest(urlParams = {}) {
  const url = urls.countryRegionsItem;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function countryRegionsCreateRequest(urlParams, data) {
  return request({
    method: 'post',
    url: urls.countryRegionsCreate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function countryRegionsUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.countryRegionsUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function countryRegionsRemoveRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.countryRegionsRemove,
    urlParams,
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/countryRegions.js